<app-nav-bar></app-nav-bar>
<router-outlet></router-outlet>
<button type="button" class="purechat-button-expand">
  <img
    src="assets/kisspng-email-box-internet-message-electronic-mailing-list-grey-5abdf31542b493.0942489915223979732732.png"
    alt=""
  />
</button>
<app-footer></app-footer>
<app-alert></app-alert>
